module.exports = __webpack_public_path__ + "static/media/Cresselia_gaussian2.26c6f4e0.png";